import React from "react";

const CheckboxColumn = ({id, dataValue, disabled = false, onChangeEmitter}) => {
    return (
        <input type="checkbox" disabled={disabled} checked={dataValue} onChange={() => onChangeEmitter(id, !dataValue)} />
    );
};
export default CheckboxColumn;
